import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { getRoleDetails } from '../../../actions/roleActions';

import RolesTable from './RolesTable';
import CreateRole from './CreateRole';

class AccountRoles extends Component {
  static propTypes = {
    accountDetail: PropTypes.instanceOf(Object),
    setActivePage: PropTypes.func,
    activePage: PropTypes.string,
    updatedActivePage: PropTypes.func,
    hasAccess: PropTypes.any,
  };

  static defaultProps = {
    activePage: 'ROLES',
    accountDetail: {},
    hasAccess: 0,
  };

  state = {
    selectedRole: {},
  };

  handleAddRoles = role => {
    if (role) {
      getRoleDetails(role.id).then(response => {
        if (response) {
          const users = _.isEmpty(response.users)
            ? []
            : _.sortBy(response.users, o => o.firstName);
          this.setState(
            {
              selectedRole: {
                ...response,
                users,
              },
            },
            () => {
              this.props.setActivePage('DETAIL');
            }
          );
        } else {
          console.log('Something went wrong on the Role details');
        }
      });
    } else {
      this.setState(
        {
          selectedRole: {},
        },
        () => {
          this.props.setActivePage('DETAIL');
        }
      );
    }
  };

  backToRolesTable = () => {
    this.setState({ selectedRole: {} }, () => {
      this.props.setActivePage('ROLES');
    });
  };

  renderContent = () => {
    const { selectedRole } = this.state;
    const { activePage } = this.props;
    const users = _.isEmpty(this.props.accountDetail.users)
      ? []
      : _.sortBy(this.props.accountDetail.users, o => o.firstName);

    const accountDetail = {
      ...this.props.accountDetail,
      users,
    };
    const isTPPAccount = accountDetail.accountType === 'TPP';

    let message = (
      <React.Fragment>
        There are no roles currently created to this account. Please click on{' '}
        <strong>Add role</strong> above to create roles.
      </React.Fragment>
    );

    if (isTPPAccount) {
      message = (
        <React.Fragment>
          A Role cannot be created or associated to a Third Party Account.
        </React.Fragment>
      );
    }

    if (activePage === 'ROLES') {
      return (
        <div className="accounts-roles-listing">
          <div className="accounts-roles-header">
            <button
              disabled={isTPPAccount || !this.props.hasAccess}
              style={{ opacity: isTPPAccount ? 0.5 : 1 }}
              onClick={() => this.handleAddRoles()}
              className="accounts-details-card-button"
            >
              <span>Add Role</span>
            </button>
          </div>
          {_.isEmpty(accountDetail.roles) || isTPPAccount ? (
            <div className="no-result-message">{message}</div>
          ) : (
            <RolesTable
              accountDetail={accountDetail}
              handleAddRoles={this.handleAddRoles}
            />
          )}
        </div>
      );
    } else if (activePage === 'DETAIL' && !isTPPAccount) {
      return (
        <CreateRole
          selectedRole={selectedRole}
          handleBack={this.backToRolesTable}
          accountDetail={accountDetail}
          roleModules={selectedRole.modules || []}
          roleUsers={selectedRole.users || []}
          roleTeams={selectedRole.teams || []}
          updatedActivePage={this.props.updatedActivePage}
          hasAccess={this.props.hasAccess}
        />
      );
    }
    return null;
  };

  render() {
    return (
      <div className="accounts-roles">
        {this.renderContent()}
      </div>
    );
  }
}

export default AccountRoles;
